//no-unused-vars 
import React, {Component} from 'react';

export const CommitteesPage = () => (
  <div className='container-fluid'>
	<div class="row">		
		&nbsp;
	</div>
	
	<div class="row">
		<div class="col-md-12">
			<h1>Committees</h1>			
		</div>
	</div>
	
	<div class="row">
		<div class="col-md-12">
			&nbsp;			
		</div>
	</div>
	
	<div class="row">
		<div class="col-md-1">
		</div>
		
		<div class="col-md-3">
			<h2>Organizing Committee</h2>		
			<ul class="list-inline">				
				<li>PhD. Małgorzata Nowak-Kępczyk (Lublin, Poland)</li>
				<li>DSc. Dariusz Partyka<sup><b>{"*"}</b></sup> Prof. KUL (Lublin & Chełm, Poland)</li>
				<li>PhD. Krzysztof Pomorski (Cracow, Poland)</li>				
				<li>PhD. Andrzej Michalski (Lublin, Poland)</li>
				<li>DSc. Mariusz Zubert<sup><b>{"*"}</b></sup> Prof. TUL (Łódź, Poland)</li>
				<li>Prof. Lino Feliciano Reséndis Ocampo (México, D.F.)</li>
                                <li>PhD. Renata Długosz (Łódź, Poland)</li>
			</ul>
			{"*"}<sup>{")"}</sup>{" Chairman"}<br/>
			&nbsp;&nbsp;<br/>
			&nbsp;&nbsp;<br/>
						
			<h2>Organizers</h2>		
			<ul class="list-inline">
				<li><a href="https://www.kul.pl/news,29385.html">Faculty of Natural Science and Health,<br/>The John Paul II Catholic University of Lublin</a><br/><br/></li>
				<li><a href="https://pwszchelm.edu.pl">Institute of Mathematics,<br/>The State School of Higher Education in Chełm</a><br/><br/></li>
				<li><a href="http://www.weeia.p.lodz.pl/en/">Faculty of Electrical, Electronic, Computer and Control Engineering,<br/>Łódź University of Technology</a><br/><br/></li>
                                <li><a href="https://ftims.p.lodz.pl/en/">Faculty of Technical Physics, Information Technology and Applied Mathematics,<br/>Łódź University of Technology</a><br/><br/></li>
                                <li><a href="https://ftims.p.lodz.pl/dla-mediow/">Institute of Physics,<br/>Faculty of Technical Physics, Information Technology and Applied Mathematics,<br/>Łódź University of Technology</a><br/><br/></li>
		                <li><a href="http://www.dmcs.lodz.pl/en/">Department of Microelectronics and Computer Science,<br/>Faculty of Electrical, Electronic, Computer and Control Engineering,<br/>Łódź University of Technology</a><br/><br/></li>
			</ul>
		</div>
			
		<div class="col-md-1">
		</div>
	
		<div class="col-md-3">
			<h2>Honorary Committee</h2>
			<ul class="list-inline">
				<li>Prof. Maria Ławrynowicz (Łódź, Poland)<br/></li>
				<li>Prof. Paweł Kowalczyk (Łódź, Poland)</li>
				<li>Prof. Antoni Różalski (Łódź, Poland)</li>
				<li>Prof. Osamu Suzuki (Tokyo, Japan)</li> 
				<li>Prof. Józef Zając (Lublin, Poland)</li>
			</ul>	

			&nbsp;&nbsp;<br/>
			&nbsp;&nbsp;<br/><br/>
						
			<h2>Honorary organisers</h2>		
			<ul class="list-inline">
				<li><a href="https://www.wfis.uni.lodz.pl/kfcs/">Department of Solid State Physics<br/>Faculty of Physics and Applied Informatics<br/>University of Lodz</a><br/><br/></li>
				<li><a href="https://www.ltn.lodz.pl/">Łódź Scientific Society</a><br/><br/></li>				
			</ul>
		</div>

		<div class="col-md-1">
		</div>
	
		<div class="col-md-3">	
			<h2>Scientific Committee</h2>
			<ul class="list-inline">		
				<li>Prof. Mikhail A. Belogolovskii (Kyiv, Ukraine)</li>				
				<li>DSc. Janusz Garecki, Prof. USZ (Szczecin, Poland)</li>
				<li>DSc. Maciej Jaworski (Cracow, Poland)</li>
				<li>DSc. Adam Lecko (Olsztyn, Poland)</li>
				<li>Prof. Jacek Leśkow (Cracow, Poland)</li>
				<li>Prof. Piotr Liczberski (Łódź, Poland)</li>
				<li>DSc. Paulius Miskinis (Vilnius, Lithuania)</li>
				<li>DSc. Dariusz Partyka<sup><b>{"*"}</b></sup> Prof. KUL (Lublin & Chełm, Poland)</li> 
				<li>Prof. Adam Paszkiewicz (Łódź, Poland)</li>
				<li>Prof. Antoni Pierzchalski (Łódź, Poland)</li>
				<li>Prof. Sergiy A. Plaksa (Kyiv, Ukrainie)</li> 
				<li>Prof. Hariton Polatoglou (Thessaloniki, Greece)</li> 
				<li>Prof. Lino Feliciano Reséndis Ocampo (México, D.F.)</li>  				
				<li>Prof. Anatoly Serdyuk (Kyiv, Ukrainie)</li>
				<li>Prof. Osamu Suzuki (Tokyo, Japan)</li> 				
				<li>Prof. Massimo Vaccaro (Salerno, Italy)</li> 				
				<li>Prof. Józef Zając (Lublin, Poland)</li>
				<li>Prof. Zhidong Zhang (Shenyang, China)</li>
				<li>DSc. Mariusz Zubert<sup><b>{"*"}</b></sup> Prof. TUL (Łódź, Poland)</li>				
			</ul>
			{"*"}<sup>{")"}</sup>{" Chairman"}<br/>
		</div>		
		
	</div>
  </div>
);
 
//export default CommitteesPage
